import { FiveStarInsuranceQuestions, FiveStarPlanDetails } from "../../../../../../../types/plan.types";

export const fiveStarInsurancePlanQuestions: FiveStarInsuranceQuestions[] = [
	{
		id: 1,
		question:
			"In the past 5 years, has been diagnosed, treated or prescribed medication by a medical professional for AIDS, AIDS related complex, or an immune system disorder?"
	},
	{
		id: 2,
		question:
			"In the past 6 months, has any Applicant been unable to work or needed personal or mechanical assistance in walking, bathing or dressing or been confined at home, been hospitalized* due to injury or sickness, excluding well-baby delivery and treatment for back pain? *Hosiptalized is defined as an admission for inpatient care in a hospital; receipt of care in a hospice facility, immediate care facility, or long-term care facility; or receipt of the following treatment wherever performed: chemotherapy, radiation therapy or dialysis?"
	},
	{
		id: 3,
		question:
			"In the past 12 months has any Applicant had diagnostic testing, surgery or hospitalization* recommended by a medical professional which has not been completed or for which the results have not been received?"
	},
	{
		id: 4,
		question:
			"In the past 5 years, has any Applicant:  Been diagnosed, treated, or prescribed medication by a medical professional for any of the following conditions: any disease or disorder of the heart, stroke, cancer, lung disease, chronic respiratory disorder (including any treatment with oxygen but excluding asthma), diabetes requiring insulin, liver or kidney disease?"
	},
	{
		id: 5,
		question:
			"In the past 5 years, has any Applicant:  Been convicted two or more times of driving under the influence of alcohol or drugs or while intoxicated?"
	},
	{
		id: 6,
		question:
			"In the past 5 years, has any Applicant:  Been treated by a medical professional or in a medical facility or received professional counseling for alcohol or drug dependency or been advised to reduce or discontinue use of alcohol?"
	},
	{
		id: 7,
		question: "In the last 10 years, has any Applicant ever applied for and been rejected for life insurance?"
	}
];
